import { store } from 'src/common/redux/configure-store';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { ActivityType } from 'src/operation-notify/enum/activities.enum';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import XLRLogger from '../../common/helpers/logger';
import { transactionStatus } from './service/transaction-status';

export const getTransactionStatus = async (
  storeId: string,
  transactionId: string,
  tillId: string,
): Promise<CartResponse> => {
  let transaction: CartResponse = {};

  if (tillId && transactionId) {
    await transactionStatus(storeId, transactionId, tillId)
      .then((result): void => {
        transaction = result;
        if (result.identifiers?.typeCode === ActivityType.ReturnTransaction) {
          store.dispatch(POSModeActions.setReturnState(ReturnsType.NonReceiptReturn));
        }
      })
      .catch(XLRLogger.error);
  }
  return transaction;
};
